import { render } from "./RemovePropertyModal.vue?vue&type=template&id=3b8b8fe5&scoped=true"
import script from "./RemovePropertyModal.vue?vue&type=script&lang=js"
export * from "./RemovePropertyModal.vue?vue&type=script&lang=js"

import "./RemovePropertyModal.vue?vue&type=style&index=0&id=3b8b8fe5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8b8fe5"]])

export default __exports__